import React from "react";
import { Input } from "@/components/ui/input";

// V1 Decor Galvá · producción/origen se decide POR COMPONENTE. Todo editable antes de aprobar.
export const ORIGENES_COMP = [
  { v: "produccion_propia", fab: "dnf", label: "DNF produce + monta" },
  { v: "cliente_a_nave", fab: "cliente", label: "Material Decor Galvá → nave DNF · sólo montaje" },
  { v: "cliente_a_pdv", fab: "cliente", label: "Material cliente → PDV · sólo montaje" },
  { v: "ya_en_pdv", fab: "cliente", label: "Ya en PDV · sólo montaje" },
];

export const nuevoComponente = () => ({
  material: "", cantidad: 1, ancho_cm: "", alto_cm: "", medidas_cliente: null, origen: "cliente_a_nave",
  fabricado_por: "cliente", aaff_pendiente: false, descripcion: "", descripcion_sugerida: "", avisos: [], regla_aplicada: "manual",
});

export function tiposDesdeComponentes(comps) {
  const s = new Set();
  for (const c of comps || []) {
    s.add("montaje");
    if (c.fabricado_por === "dnf") s.add("produccion");
  }
  return ["produccion", "montaje"].filter((t) => s.has(t));
}

const cls = "bg-zinc-950 border-zinc-800 h-7 text-[11px] px-1.5";

export function ComponentesBorradorEditor({ comps, onChange, lineaIdx }) {
  const upd = (j, patch) => onChange(comps.map((c, k) => (k === j ? { ...c, ...patch } : c)));
  const setOrigen = (j, v) => {
    const o = ORIGENES_COMP.find((x) => x.v === v);
    upd(j, { origen: v, fabricado_por: o?.fab || "cliente", aaff_pendiente: o?.fab === "dnf" ? comps[j].aaff_pendiente : false, regla_aplicada: "editado a mano" });
  };
  return (
    <div className="mt-2 border-t border-zinc-800/70 pt-2" data-testid={`componentes-linea-${lineaIdx}`}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-[10px] text-zinc-500 uppercase tracking-wider">Componentes ({comps.length}) · producción decidida por pieza</span>
        <button type="button" onClick={() => onChange([...comps, nuevoComponente()])}
          data-testid={`add-componente-${lineaIdx}`} className="text-[10px] text-emerald-300 hover:text-emerald-200 underline">+ componente</button>
      </div>
      {comps.length === 0 && <div className="text-[10px] text-amber-300/80 italic">Sin componentes: la línea se creará sin piezas.</div>}
      <div className="space-y-1.5">
        {comps.map((c, j) => (
          <div key={j} className={`rounded border p-1.5 ${c.fabricado_por === "dnf" ? "border-orange-500/30 bg-orange-500/5" : "border-zinc-800 bg-zinc-950/40"}`}
            data-testid={`componente-${lineaIdx}-${j}`}>
            <div className="grid grid-cols-12 gap-1.5 items-end">
              <div className="col-span-2">
                <div className="text-[9px] text-zinc-500">Material</div>
                <Input value={c.material || ""} onChange={(e) => upd(j, { material: e.target.value })} className={cls} data-testid={`comp-material-${lineaIdx}-${j}`} />
              </div>
              <div className="col-span-1">
                <div className="text-[9px] text-zinc-500">Cant.</div>
                <Input type="number" min="1" value={c.cantidad ?? 1} onChange={(e) => upd(j, { cantidad: Number(e.target.value) || 1 })} className={cls} data-testid={`comp-cantidad-${lineaIdx}-${j}`} />
              </div>
              <div className="col-span-1">
                <div className="text-[9px] text-zinc-500">Ancho</div>
                <Input value={c.ancho_cm ?? ""} onChange={(e) => upd(j, { ancho_cm: e.target.value })} className={cls} data-testid={`comp-ancho-${lineaIdx}-${j}`} />
              </div>
              <div className="col-span-1">
                <div className="text-[9px] text-zinc-500">Alto</div>
                <Input value={c.alto_cm ?? ""} onChange={(e) => upd(j, { alto_cm: e.target.value })} className={cls} data-testid={`comp-alto-${lineaIdx}-${j}`} />
              </div>
              <div className="col-span-4">
                <div className="text-[9px] text-zinc-500">Producción / origen del material</div>
                <select value={c.origen || "cliente_a_nave"} onChange={(e) => setOrigen(j, e.target.value)}
                  data-testid={`comp-origen-${lineaIdx}-${j}`}
                  className="w-full bg-zinc-950 border border-zinc-800 rounded h-7 text-[11px] px-1 text-zinc-200">
                  {ORIGENES_COMP.map((o) => <option key={o.v} value={o.v}>{o.label}</option>)}
                </select>
              </div>
              <div className="col-span-2 flex items-center gap-1 h-7">
                <label className={`flex items-center gap-1 text-[10px] ${c.fabricado_por === "dnf" ? "text-sky-200" : "text-zinc-600"}`}>
                  <input type="checkbox" disabled={c.fabricado_por !== "dnf"} checked={!!c.aaff_pendiente}
                    onChange={(e) => upd(j, { aaff_pendiente: e.target.checked })} data-testid={`comp-aaff-${lineaIdx}-${j}`} className="accent-sky-400" />
                  AAFF pendiente
                </label>
              </div>
              <div className="col-span-1 flex justify-end">
                <button type="button" onClick={() => onChange(comps.filter((_, k) => k !== j))} data-testid={`del-componente-${lineaIdx}-${j}`}
                  className="text-[10px] text-zinc-500 hover:text-red-300">✕</button>
              </div>
              <div className="col-span-12">
                <div className="text-[9px] text-zinc-500">Descripción (sugerida, editable)</div>
                <Input value={c.descripcion || c.descripcion_sugerida || ""} onChange={(e) => upd(j, { descripcion: e.target.value })}
                  className={cls} data-testid={`comp-descripcion-${lineaIdx}-${j}`} />
              </div>
            </div>
            <div className="flex flex-wrap gap-2 mt-1 text-[9px]">
              {c.regla_aplicada && <span className="text-zinc-500">Regla: {c.regla_aplicada}</span>}
              {c.medidas_cliente?.texto && <span className="text-zinc-500">Medida cliente: «{c.medidas_cliente.texto}»</span>}
              {(c.avisos || []).map((a, k) => <span key={k} className="text-amber-300" data-testid={`comp-aviso-${lineaIdx}-${j}-${k}`}>⚠ {a}</span>)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
